<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  // components: {
  //   HelloWorld
  // },
  // data() {
  //   return {
  //     options3: [{
  //       label: '热门城市',
  //       options: [{
  //         value: 'Shanghai',
  //         label: '上海'
  //       }, {
  //         value: 'Beijing',
  //         label: '北京'
  //       }]
  //     }, {
  //       label: '城市名',
  //       options: [{
  //         value: 'Chengdu',
  //         label: '成都'
  //       }, {
  //         value: 'Shenzhen',
  //         label: '深圳'
  //       }, {
  //         value: 'Guangzhou',
  //         label: '广州'
  //       }, {
  //         value: 'Dalian',
  //         label: '大连'
  //       }]
  //     }],
  //     value7: ''
  //   }
  // }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

</style>
